import { Card } from '@mui/material';
import { type FC } from 'react';

interface Props {
  id: string;
}

export const PowerApp: FC<Props> = ({ id }) => (
  <Card sx={{ height: '100%' }}>
    <iframe
      title="PowerApp"
      width="100%"
      height="100%"
      src={`https://apps.powerapps.com/play/${id}?source=website`}
    />
  </Card>
);
